"use client"
import React, {FC} from 'react';
import {toPersianNumber} from "@/core/utils/number.utils";
import {Column} from "@/core/general/column.component";
import {VIDEO_GARDI_MOVIES_PATH, VIDEO_GARDI_SERIES_PATH} from "@/core/CONSTANTS";
import {VideoGardiLngModel, VideoGardiModel} from "@/core/model/tmk.model";
import {useRouter} from "next/navigation";
import Image from "next/image";

interface ShortcutProps {
  video: VideoGardiModel;
  index: number;
  widgetTitle: string | null;
}

const VideoGardiHorizontalComponent: FC<ShortcutProps> = (props) => {
  const router = useRouter();

  function videoClick(id:string,type:string,title:string) {
    router.push(((type==="MOVIE")?VIDEO_GARDI_MOVIES_PATH:VIDEO_GARDI_SERIES_PATH)+`${id}/?shTitle=${title}`);
  }

  return (
    <div className="w-full">
      {props.video ? (
        <Column className="p-1 cursor-pointer !w-36 mx-1" onClick={() => videoClick(props.video.id,props.video.type,(props.video.title as VideoGardiLngModel)?.fa)}>
          <div className="aspect-[2/3] relative rounded-xl flex flex-col shortVideoIconImage">
            <Image fill={true} alt="" src={props.video?.gallery?.poster??""} className="w-full grow card card-box !relative"  quality={50} loading="lazy"/>
          </div>
          <div className="fs-7 px-2 text-center truncate mt-2 h-6 py-1 mText">
            {toPersianNumber((props.video.title as VideoGardiLngModel)?.fa)}
          </div>
        </Column>
      ) : null}
    </div>
  );
};

export default React.memo(VideoGardiHorizontalComponent)
